export const DOCTOR_CONTACT = {
  name: "Dr. Gaurav B. Modi",
  email: "gauravmodi912@gmail.com",
  phone: "82387 61751",
  clinicPhone: "91572 60376",
  facebook: "https://www.facebook.com/share/1BycZS3A1v/",
  instagram: "https://www.instagram.com/gauravmodi912?igsh=MTFxMXN5dmt0OGsxNw==",
  linkedin: "https://www.linkedin.com/in/prakashmodi11191/",
};

export const sendAppointmentForm = async (data: {
  name: string;
  phone: string;
  clinic: string;
  message: string;
}) => {
  try {
    // Prepare the data
    const formData = {
      timestamp: new Date().toISOString(),
      patientName: data.name,
      patientPhone: data.phone,
      preferredClinic: data.clinic === "0" ? "Ashtamangal Surgical Hospital" : "Invictus Gastro Hospital",
      message: data.message || "No additional message",
      doctorEmail: DOCTOR_CONTACT.email,
      doctorPhone: DOCTOR_CONTACT.phone,
      clinicPhone: DOCTOR_CONTACT.clinicPhone,
    };

    // Send WhatsApp message to doctor
    const whatsappMessage = `New Appointment Request:\n\nName: ${data.name}\nPhone: ${data.phone}\nClinic: ${formData.preferredClinic}\nMessage: ${data.message || "No message"}`;
    const whatsappUrl = `https://wa.me/${DOCTOR_CONTACT.phone.replace(/\s/g, "")}?text=${encodeURIComponent(whatsappMessage)}`;

    // Send WhatsApp message to clinic
    const clinicWhatsappUrl = `https://wa.me/${DOCTOR_CONTACT.clinicPhone.replace(/\s/g, "")}?text=${encodeURIComponent(whatsappMessage)}`;

    // Attempt to send via backend webhook (if available)
    try {
      const webhookUrl = process.env.REACT_APP_WEBHOOK_URL || "https://formspree.io/f/YOUR_FORM_ID";

      const response = await fetch(webhookUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });

      if (!response.ok) {
        console.warn("Backend submission failed, but user will be prompted to share via WhatsApp");
      }
    } catch (error) {
      console.log("Backend not available, using WhatsApp for notification");
    }

    // Return the URLs for user to complete action
    return {
      success: true,
      whatsappUrl,
      clinicWhatsappUrl,
      message: "Your appointment request has been prepared. Please click the WhatsApp button to send to the doctor.",
    };
  } catch (error) {
    console.error("Error processing appointment form:", error);
    return {
      success: false,
      error: "Failed to process appointment request",
    };
  }
};
